<div class="engine-body">
  <div class="tab-content engine__tab-content" id="myTabEngine">
    <app-engine-holiday
      [engineTabType]="engineTabTypes.Holiday"
      [holidaySearchParams]="holidaySearchParams"
      *ngIf="selectedTab===engineTabTypes.Holiday"></app-engine-holiday>
    <app-engine-holiday
      [engineTabType]="engineTabTypes.Tour"
      [holidaySearchParams]="holidaySearchParams"
      *ngIf="selectedTab===engineTabTypes.Tour"></app-engine-holiday>
    <app-engine-cruise
      [cruiseSearchParams]="cruiseSearchParams"
      *ngIf="selectedTab===engineTabTypes.Cruise"></app-engine-cruise>
    <app-engine-bus *ngIf="selectedTab===engineTabTypes.Bus"></app-engine-bus>
    <app-engine-merlinx-flights *ngIf="selectedTab===engineTabTypes.Flight"></app-engine-merlinx-flights>
    <app-engine-merlinx-hotels *ngIf="selectedTab===engineTabTypes.Hotel"></app-engine-merlinx-hotels>
    <app-engine-merlinx-carrental *ngIf="selectedTab===engineTabTypes.CarRental"></app-engine-merlinx-carrental>
    <app-engine-merlinx-parkings *ngIf="selectedTab===engineTabTypes.Parking"></app-engine-merlinx-parkings>
    <app-engine-smartbox *ngIf="selectedTab===engineTabTypes.SmartBox"></app-engine-smartbox>
    <!--<engine-welcome-to-italy *ngIf="selectedTab===engineTabTypes.WelcomeToItaly"></engine-welcome-to-italy>-->

  </div>
</div>
